import { ApolloClient, InMemoryCache } from '@apollo/client';
import { split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { HttpLink } from '@apollo/client';
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_AETHER_GRAPHQL_URL,
});

const wsLink = new GraphQLWsLink(
  createClient({
    url: `${process.env.REACT_APP_BROKER_WS_API_URL}/graphql`, 
    options: {
      reconnect: true,
    },
  })
);

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpLink,
);

const AetherClient = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});

export default AetherClient;
